/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from "@atproto/lex";

const $nsid = "place.stream.moderation.deleteGate";

export { $nsid };

export const $params = /*#__PURE__*/ l.params();

export type $Params = l.InferOutput<typeof $params>;

export const $input = /*#__PURE__*/ l.jsonPayload({"streamer":/*#__PURE__*/ l.string({"format":"did"}),"gateUri":/*#__PURE__*/ l.string({"format":"at-uri"})});

export type $Input<B = l.BinaryData> = l.InferPayload<typeof $input, B>;
export type $InputBody<B = l.BinaryData> = l.InferPayloadBody<typeof $input, B>;

export const $output = /*#__PURE__*/ l.jsonPayload({});

export type $Output<B = l.BinaryData> = l.InferPayload<typeof $output, B>;
export type $OutputBody<B = l.BinaryData> = l.InferPayloadBody<typeof $output, B>;

/** Delete a gate (unhide message) on behalf of a streamer. Requires 'hide' permission. Deletes a place.stream.chat.gate record from the streamer's repository. */
const main = /*#__PURE__*/ l.procedure($nsid, $params, $input, $output, ["Unauthorized","Forbidden","SessionNotFound"]);

export { main };

export const $lxm = $nsid;
